import Link from "next/link";
import React from "react";
import TabData from "../../data/toolsBanner.json";

const ToolsBanner = () => {
  return (
    <>
      <div className="row row--30 align-items-center">
        <div className="col-lg-12">
          <div className="rainbow-default-tab style-three generator-tab-defalt">
            <div className="rainbow-tab-content tab-content">
              {TabData &&
                TabData.ToolsBanner.map((tab, index) => (
                  <div
                    className={`tab-pane fade ${
                      tab.isSelect ? "show active" : ""
                    }`}
                    id={tab.target}
                    role="tabpanel"
                    aria-labelledby={`${tab.menuId}-tab`}
                    key={index}
                  >
                    <div className="inner">
                      <div className="row">
                        <div className="col-xl-6">
                          <div className="section-title">
                            <h2 className="title">{tab.title}</h2>
                            <div className="features-section">
                              <ul className="list-style--1">
                                {tab.subItem.map((item, i) => (
                                  <li key={i}>
                                    <i className="fa-regular fa-circle-check"></i>
                                    {item.text}
                                  </li>
                                ))}
                              </ul>
                            </div>
                            <div className="read-more">
                              <Link
                                className="btn-default color-blacked"
                                href="/registrarse"
                              >
                                Comienza explorando ahora
                                <i className="fa-sharp fa-solid fa-arrow-right ps-2"></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-6 mt_md--30 mt_sm--30">
                          <div className="export-img">
                            <div className="inner-without-padding">
                              <div className="export-img img-bg-shape">
                                <video
                                  autoPlay
                                  loop
                                  muted
                                  playsInline
                                  width={569}
                                  height={483}
                                >
                                  <source src={tab.img} type="video/webm" />
                                </video>
                                <div className="image-shape"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ToolsBanner;
